var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcBaselineMode = function SvgIcBaselineMode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 14.375V17.5h3.75l11.06-9.217-3.75-3.125zm17.71-9.683-2.34-1.95a1 1 0 0 0-.323-.18 1.17 1.17 0 0 0-.764 0q-.182.062-.323.18l-1.83 1.525 3.75 3.125 1.83-1.525a.8.8 0 0 0 .216-.27.71.71 0 0 0 0-.636.8.8 0 0 0-.216-.27"
  })));
};
export default SvgIcBaselineMode;